import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isString } from 'lodash';
import { DateTime } from 'luxon';
import type {
  OnyxTime,
  OnyxTimeRange,
} from '../components/timepicker/interfaces';
import type { OnyxOptional } from '../interfaces';

export const TIME_PATTERN = /^(?:[01]\d|2[0-3]):[0-5]\d:00$/;

@Pipe({
  name: 'onyxTime',
})
export class OnyxTimePipe implements PipeTransform {
  public transform(
    value: OnyxOptional<DateTime | (OnyxTime | string) | OnyxTimeRange>,
    options?: { showGap?: boolean },
  ): string {
    if (!value) return '-';

    if (DateTime.isDateTime(value)) return value.toFormat('HH:mm');
    if (isString(value)) return this.formatTime(value);

    value = value as OnyxTimeRange;

    const { showGap = true } = options ?? {};
    const from = this.formatTime(value.from);
    const to = this.formatTime(value.to);

    return `${from}${showGap ? ' - ' : '-'}${to}`;
  }

  private formatTime(time: OnyxTime | string): string {
    if (TIME_PATTERN.test(time)) return time.slice(0, 5);
    return DateTime.fromISO(time).toFormat('HH:mm');
  }
}
